export const name = 'wixCustomElementComponent' as const
export const WixCustomElementComponentAPISymbol = Symbol('WixCustomElementComponentAPISymbol')
export const WixCustomElementComponentEditorAPISymbol = Symbol('WixCustomElementComponentEditorAPISymbol')
export { VSM_EDITOR_CONFIGS_EXPERIMENT as editorExperiment } from '@wix/thunderbolt-symbols'
